import React from "react";
var __jsx = React.createElement;
import { useContext, useEffect, useState } from 'react';
import { ImagePreview } from 'components/common/ImagePreview';
import useGetBlockData from 'components/common/RichTextEditor/hooks/useGetBlockData';
import { RichTextEditorMethodsContext } from 'components/common/RichTextEditor/types';
import { Container } from './ImageBlock.style';

var ImageBlock = function ImageBlock(_ref) {
  var block = _ref.block,
      editorState = _ref.blockProps.editorState;

  var _useState = useState(''),
      imgUrl = _useState[0],
      setImgUrl = _useState[1];

  var _useState2 = useState(true),
      openModal = _useState2[0],
      setOpenModal = _useState2[1];

  var _useContext = useContext(RichTextEditorMethodsContext),
      removeBlock = _useContext.removeBlock,
      updateBlockData = _useContext.updateBlockData;

  var _useGetBlockData = useGetBlockData(editorState, block.getKey(), block.getEntityAt(0)),
      blockData = _useGetBlockData.blockData,
      entityData = _useGetBlockData.entityData;

  useEffect(function () {
    setOpenModal(blockData.openModal);
    setImgUrl(entityData.imgUrl);
  }, [blockData, entityData]);
  return __jsx(Container, null, (imgUrl || !openModal) && __jsx(ImagePreview, {
    imageData: {
      imgUrl: imgUrl,
      credits: '',
      legend: ''
    },
    onClickEdit: function onClickEdit() {
      return updateBlockData(block.getKey(), {
        openModal: true
      });
    },
    onClickRemove: function onClickRemove() {
      return removeBlock(block.getKey());
    },
    includedModal: false
  }));
};

export default ImageBlock;